import { Select } from "@mixitone/components";
import { Account, type ClubPlayer, type Group } from "@mixitone/models";
import { ApplicationView } from "@mixitone/mvc";
import { isNil } from "@mixitone/util";
import { GroupSelect } from "components/GroupSelect";

interface Props {
  player: ClubPlayer;
  clubGroups: Group[];
  onSelectGroup: (group: Group) => void;
  onSelectLevel: (level: number) => void;
  className?: string;
  children?: React.ReactNode;
}

const ClubPlayerGroupLevelControlView = ({
  player,
  clubGroups,
  onSelectGroup,
  onSelectLevel,
  className = "flex items-center justify-center gap-2 whitespace-nowrap py-0 @sm/app:justify-start [&_.group-name]:hidden [&_.group-name]:@sm/app:inline",
  children,
}: Props) => {
  return (
    <div className={className}>
      <GroupSelect
        className="min-h-0"
        clubGroups={clubGroups}
        value={player.group}
        onSelectGroup={(group) => {
          if (isNil(group)) return;
          onSelectGroup(group);
        }}
        compact
      >
        {children}
      </GroupSelect>
      {Account.current?.hasFeature("group_levels") && player.group?.graduation_enabled && (
        <Select
          compact
          value={String(player.graduation_level ?? 1)}
          onChange={(e) => {
            onSelectLevel(Number(e.target.value));
          }}
          className="m-0 w-[4.5rem] pl-1"
          aria-label={`Graduation level for ${player.name}`}
        >
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
        </Select>
      )}
    </div>
  );
};

export const ClubPlayerGroupLevelControl = ApplicationView(ClubPlayerGroupLevelControlView);
